import { sendEvent as apiSendEvent } from '~/api/misc2';

export default async function sendEvent(eventType: string, detail: unknown = '', organization?: string) {
  await apiSendEvent(eventType, detail, organization);
}
